export const Arrow = () => (
  <div className="lil-w-1/6 xl:lil-w-1/12 lil-m-4 sm:lil-flex sm:lil-justify-center sm:lil-my-8 sm:lil-w-full">
    <img
      src="https://assets1.cleartax-cdn.com/cleartax/images/1605952657_arrowdown.svg"
      height="20"
      width="20"
    />
  </div>
);



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/stepsToInvest/arrow.tsx